export default __webpack_public_path__ + "static/media/3.82293090.jpg";